import { render } from "./ImageSettings.vue?vue&type=template&id=3dc637d6&scoped=true"
import script from "./ImageSettings.vue?vue&type=script&lang=js"
export * from "./ImageSettings.vue?vue&type=script&lang=js"

import "./ImageSettings.vue?vue&type=style&index=0&id=3dc637d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc637d6"]])

export default __exports__